import { useEffect, useRef, useState } from "react"
import { getWhitelist } from "services/appService";
import WhitelistIpModel from 'models/WhitelistIp'
export const useGetWhitelist = (params) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const paging = useRef({
        pageIndex: 1,
        pageSize: 10,
        totalCount: 10
    })
    const getList = async () => {
        setIsLoading(true);
        try {
            const response = await getWhitelist(params);
            if(response) {
                setData(response.result.map(el => new WhitelistIpModel(el)));
                paging.current = {
                    pageIndex: response.pageIndex,
                    pageSize: response.pageSize,
                    totalCount: response.totalCount
                }
            }
            setIsLoading(false);
        } catch (error) {
            setError(error);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getList();
    },[params])

    const reLoadData = () => {
        getList()
    }

    return {data, isLoading, error, paging, reLoadData}
}
